module.exports = new __parcel__URL__("logo_cpm.405128db.png").toString();